// frontend/src/components/ScrollCatAnimation.js
import React, {useRef} from 'react';
import {motion, useScroll, useTransform} from 'framer-motion';

const ScrollCatAnimation = () => {
    const containerRef = useRef(null);
    const {scrollYProgress} = useScroll({
        target: containerRef,
        offset: ['start end', 'end start']
    });

    // Лапки
    const paws = [
        {
            opacity: useTransform(scrollYProgress, [0.15, 0.20, 0.25, 0.30], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.05, 0.15], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.20, 0.25, 0.30, 0.35], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.10, 0.20], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.25, 0.30, 0.35, 0.40], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.15, 0.25], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.30, 0.35, 0.40, 0.45], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.20, 0.30], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.35, 0.40, 0.45, 0.50], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.25, 0.35], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.40, 0.45, 0.50, 0.55], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.30, 0.40], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.45, 0.50, 0.55, 0.60], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.35, 0.45], [0, 5])
        },
        {
            opacity: useTransform(scrollYProgress, [0.50, 0.55, 0.60, 0.65], [0, 1, 1, 0]),
            x: useTransform(scrollYProgress, [0.40, 0.50], [0, 5])
        }
    ];

    // Кот
    const catOpacity = useTransform(scrollYProgress, [0.50, 0.60, 0.80], [0, 1, 1]);
    const catX = useTransform(scrollYProgress, [0.4, 0.65], ['-100%', '0%']);

    // Позиции лапок
    const pawPositions = [
        {top: '8.89%', left: '58%'},   // 40px → 8.89%
        {top: '17.78%', left: '66%'},  // 80px → 17.78%
        {top: '31.11%', left: '62%'},  // 140px → 31.11%
        {top: '40%', left: '70%'},     // 180px → 40%
        {top: '53.33%', left: '66%'},  // 240px → 53.33%
        {top: '62.22%', left: '74%'},  // 280px → 62.22%
        {top: '75.56%', left: '70%'},  // 340px → 75.56%
        {top: '84.44%', left: '78%'}   // 380px → 84.44%
    ];

    return (
        <div
            ref={containerRef}
            className="relative w-full bg-white overflow-hidden"
            style={{aspectRatio: '1000 / 450'}}
        >
            {/* Лапки – абсолютное позиционирование с процентами */}
            {paws.map((paw, idx) => (
                <motion.img
                    key={idx}
                    src="/images/animation/paw.svg"
                    alt=""
                    className="absolute h-auto"
                    style={{
                        top: pawPositions[idx].top,
                        left: pawPositions[idx].left,
                        width: '5%',            // 50px при ширине 1000px → 5%
                        opacity: paw.opacity,
                        x: paw.x,
                    }}
                />
            ))}

            {/* Кот – выезжает слева */}
            <motion.img
                src="/images/animation/cat.svg"
                alt=""
                className="absolute h-auto"
                style={{
                    top: '33.33%',             // 150px / 450px = 33.33%
                    left: 0,
                    width: '9.7%',             // 97px / 1000px = 9.7%
                    opacity: catOpacity,
                    x: catX,
                }}
            />
        </div>
    );
};

export default ScrollCatAnimation;